import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { updateData } from "../../api/api";

// Wrapper needed for react-beautiful-dnd compatibility with React 18 StrictMode
const StrictModeDroppable = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);
  if (!enabled) return null;
  return <Droppable {...props}>{children}</Droppable>;
};

function ReorderSubcategoriesModal({
  show,
  handleClose,
  category,
  onSave,
}) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (show && category?.subcategories) {
      const sorted = [...category.subcategories].sort(
        (a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0)
      );
      setItems(sorted);
    }
  }, [show, category]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(items);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    setItems(reordered);
  };

  const handleSave = async () => {
    const payload = items.map((item, index) => ({
      id: item.id,
      sort_order: index,
    }));
    try {
      await updateData(
        "categories",
        `${category.id}/reorder_subcategories`,
        { subcategories: payload },
        false
      );
      onSave(
        items.map((item, index) => ({ ...item, sort_order: index }))
      );
      handleClose();
    } catch (error) {
      console.error("Fehler beim Speichern der Reihenfolge:", error);
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          Reihenfolge: {category?.name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ color: "#666", marginBottom: "12px", fontSize: "14px" }}>
          Ziehen Sie die Unterordner in die gewünschte Reihenfolge.
        </p>
        <DragDropContext onDragEnd={handleDragEnd}>
          <StrictModeDroppable droppableId="subcategory-list">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {items.map((sub, index) => (
                  <Draggable
                    key={String(sub.id)}
                    draggableId={String(sub.id)}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          padding: "10px 12px",
                          marginBottom: "6px",
                          borderRadius: "6px",
                          backgroundColor: snapshot.isDragging
                            ? "#e8e0f0"
                            : sub.bg_color || "#f5f5f5",
                          color: sub.font_color || "#000",
                          border: "1px solid #ddd",
                          cursor: "grab",
                          ...provided.draggableProps.style,
                        }}
                      >
                        <DragIndicatorIcon
                          style={{ marginRight: "10px", opacity: 0.6 }}
                        />
                        {sub.name}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </StrictModeDroppable>
        </DragDropContext>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Abbrechen
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Speichern
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ReorderSubcategoriesModal;
